export default __webpack_public_path__ + "static/media/postmark-negative.c251f1cf.svg";